import React from "react";
import FormPage from "../../components/forms/FormPage";
import FormSelectField from "../../components/forms/fields/basic/SelectField";
import FormTextField from "../../components/forms/fields/basic/TextField";
import { IntellexusDateField } from "../../components/forms/common/intellexusDate/IntellexusDateField";
import FormAutoCompleteField from "../../components/forms/fields/basic/AutoCompleteField";
import AccordionSubFormContainer from "../../components/forms/fields/subForms/accordion/AccordionSubFormContainer";
import AccordionSubForm from "../../components/forms/fields/subForms/accordion/AccordionSubForm";
import LinksListField from "../../components/forms/common/subForms/LinksListField";
import LanguagesListField from "../../components/forms/common/subForms/LanguagesListField";
import { useParams } from "react-router-dom";
import usePersonController from "../../controllers/personController";
import { Person } from "../../types/person";
import PersonNameInternalEvidence from "./PersonNameInternalEvidence";
import PersonNameInternalEvidenceList from "./PersonNameInternalEvidenceList";
import usePersonLogic from "../../hooks/logic/personLogic";
import FormEntitySelectionField from "../../components/forms/fields/basic/EntitySelectionField";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import renderPlaceSelection from "../../components/entitiesReferences/SelectionModals/PlaceSelectionModal";
interface AddEditPersonFormProps {
  sections: (person: Person) => React.ReactElement[];
}

const AddEditPersonForm: React.FC<AddEditPersonFormProps> = ({ sections }) => {
  const { _id = null } = useParams<{ _id?: string }>();

  const controller = usePersonController(_id);
  const formController = { ...controller, title: controller.editTitle };
  const {
    personRolesEnum,
    personGenderEnum,
    personOriginEnum,
    personLanguagesEnum,
    personLinksTypeEnum,
    affiliatedTraditionsEnum,
  } = usePersonLogic();

  const { isCreateMode } = controller;

  return (
    <FormPage controller={formController} sections={sections}>
      <FormTextField name="name" label="Name" placeholder="Name" />
      {isCreateMode ? (
        <FormSelectField
          name="origin"
          label="Origin"
          placeholder="Select origin"
          useEnum={personOriginEnum}
          required
        />
      ) : (
        <FormTextField name="origin" label="Origin" static />
      )}
      <FormSelectField
        name="gender"
        label="Gender"
        placeholder="Select Gender"
        useEnum={personGenderEnum}
      />
      <AccordionSubFormContainer>
        <AccordionSubForm
          name="name_internal_evidence"
          label="Name Internal Evidence"
        >
          <PersonNameInternalEvidence />
        </AccordionSubForm>
      </AccordionSubFormContainer>
      <FormTextField
        name="primary_title_type"
        label="Primary Title Type"
        placeholder="Primary Title Type"
      />
        <FormEntitySelectionField
          name="place_of_birth"
          label="Place of Birth"
          placeholder="Select a place of birth"
          entityCollection={SystemEntityCollections.PLACE}
          renderEntitySelection={renderPlaceSelection}
        />
      <IntellexusDateField name="floruit" label="Floruit" />
      <IntellexusDateField name="date_of_birth" label="Date of Birth" />
      <IntellexusDateField name="date_of_death" label="Date of Death" />
      <FormAutoCompleteField
        name="affiliated_traditions"
        label="Affiliated Traditions"
        placeholder="Select affiliated traditions"
        useEnum={affiliatedTraditionsEnum}
        multiple
      />
       <FormEntitySelectionField
          name="region_of_activity"
          label="Region of Activity"
          placeholder="Select a region of activity"
          entityCollection={SystemEntityCollections.PLACE}
          renderEntitySelection={renderPlaceSelection}
        />

      <PersonNameInternalEvidenceList
        name="other_designations"
        label="Other Designations"
        rowLabel="Other Designation"
      />
      <LanguagesListField
        name="languages"
        label="Languages"
        rowLabel="Languages"
        rolesLabel="Roles"
        languagesLabel="Languages"
        rolesEnum={personRolesEnum}
        languagesEnum={personLanguagesEnum}
      />
      <LinksListField
        name="link_to_other_databases"
        typeEnum={personLinksTypeEnum}
        label="Links"
        rowLabel="Link"
        typeLabel="Link Type"
        valueLabel="Link"
        typePlaceHolder="Select link type"
        valuePlaceHolder="Enter Link"
      />
    </FormPage>
  );
};

export default AddEditPersonForm;
